module.exports = __webpack_public_path__ + "helveticaneue_thin-webfont.ff010c151beca4978747.woff2";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/assets/fonts/helveticaneue_thin-webfont.woff2
// module id = ../../../../../src/assets/fonts/helveticaneue_thin-webfont.woff2
// module chunks = styles